import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.pruefaufgabe-kopieren';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefaufgabeKopierenEffects {

    PruefaufgabeKopieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFAUFGABE_KOPIEREN),
        mergeMap((x: ac.PostPruefaufgabeKopierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPruefaufgabeKopieren(x.pruefaufgabeRequest).pipe(
                map((result: any) => {
                    return new ac.PostPruefaufgabeKopierenErfolgreichAction(result, x.pruefaufgabeRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPruefaufgabeKopierenFehlerAction(error, x.pruefaufgabeRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
